// export interface IRequests {}

export enum ERequestsResponseStatus {
	success = 'success',
	warning = 'warning',
	error = 'error',
	unknown = 'unknown',
}
